import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

const AuthCallbackPage = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <CircularProgress />
      <Typography variant="h6" marginTop={2}>
        Logging in, please wait...
      </Typography>
    </Box>
  );
};

export default AuthCallbackPage;
